/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StageMappingItem {
  id: string;
  stage_id: string;
  stage_name: string;
  stage_position: number;
  is_system: boolean;
  remote_stage_id: string | null;
  match_source: string;
  is_synced: boolean;
  needs_mapping?: boolean;
  archive_resolution?: string | null;
  origin_ats_name?: string | null;
}
